<template>
  <page-wrapper :title="title">
    <div v-if="receipt" class="container">
      <div class="mb-3">
        <div v-if="isOfflineUser" class="offline-user mb-3">ซื้อนอกระบบ (ไม่มีผู้ใช้ในระบบ)</div>
        <div v-if="receipt.isManualPayment" class="offline-user mb-3">ซื้อนอกระบบ</div>
        <div v-if="receipt.isNonVerifySales" class="offline-user mb-3">ซื้อโดยไม่สมัคร App</div>
        <div class="col" style="padding: 0;">
            <div class="label">เลือกภาษาที่ต้องการออกใบเสร็จ</div>
            <div class="mt-1">
              <el-select
                id="language"
                v-model="selectedLanguage"
                name="language"
                placeholder=""
                style="width: 240px; height: 40px;"
              >
                <el-option
                  v-for="item in languageOptions"
                  :key="item.value"
                  :value="item"
                >
                  <span style="color: #4A4A4A;">
                    <img
                      :src="item.icon"
                      width="24"
                      height="24"
                      style="margin-right: 12px;"
                    />
                    {{ item.label }}
                  </span>
                </el-option>
                <span
                  v-if="selectedLanguage"
                  slot="prefix"
                  style="
                    display: flex;
                    align-items: center;
                    height: 100%;
                    padding-left: 12px;
                    color: #4A4A4A;
                  "
                >
                  <img
                    :src="selectedLanguage.icon"
                    width="24"
                    height="24"
                    style="margin-right: 12px;"
                  />
                  {{ selectedLanguage.label }}
                </span>
              </el-select>
            </div>
          </div>
        <div class="row mt-4">
          <div class="col col-lg-4">
            <div class="label">
              วันที่
              <sc-button
                :disabled="isViewOnlyByRole"
                variant="secondary"
                size="sm"
                @click="handleClickChangeIssuedAtButton"
                >แก้ไขวันที่</sc-button
              >
            </div>
            <div class="text">{{ receipt.issuedAt }}</div>
          </div>
          <div class="col col-lg-4">
            <div class="label">เลขที่</div>
            <div class="text">{{ receipt.no }}</div>
          </div>
          <div class="col col-lg-4">
            <div class="label">ผู้จัดหาบริการ</div>
            <div class="text">{{ receipt.sellerTradePartyName }}</div>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="row">
          <div class="col col-lg-4">
            <div class="label">
              ผู้รับบริการ
              <sc-button
                :disabled="canNotEditAddress || isViewOnlyByRole"
                variant="secondary"
                size="sm"
                @click="handleClickChangeClientNameButton"
                >แก้ไขชื่อ</sc-button
              >
              <div v-if="isHasToEditOwnerName" class="offline-user-detail">
                *ต้องแก้ไขชื่อผู้รับบริการก่อนส่ง eztax
              </div>
            </div>
            <div class="text mb-4">{{ form.name }}</div>
          </div>
          <div v-show="isCreditNote" class="col col-lg-4">
            <div class="label">เลขที่เอกสารเดิม</div>
            <div class="text">{{ receipt.referenceDocumentNumber }}</div>
          </div>
        </div>
        <div class="label">
          ที่อยู่ผู้รับบริการ
          <sc-button
            :disabled="canNotEditAddress || isViewOnlyByRole"
            variant="secondary"
            size="sm"
            @click="handleClickChangeAddressButton"
            >แก้ไขที่อยู่</sc-button
          >
        </div>
        <div>
          <div v-if="!isLangDefault()" class="warning mt-1">* กรุณาแก้ไขที่อยู่ตามภาษาที่เลือก</div>
          <div class="text">{{ receipt.client.addressLine1 }}</div>
          <div class="text">{{ receipt.client.addressLine2 }}</div>
        </div>
        <div v-show="isCreditNote" class="mt-4">
          <div class="label">หมายเหตุของการยกเลิกเอกสาร</div>
          <div class="text">{{ receipt.purpose }}</div>
        </div>
        <div class="label mt-4">
          เลขประจำตัวผู้เสียภาษี
          <sc-button
            :disabled="canNotEditAddress || isViewOnlyByRole"
            variant="secondary"
            size="sm"
            @click="handleClickChangeTaxIdButton"
          >แก้ไขเลขประจำตัวผู้เสียภาษี</sc-button>
          <div v-if="isHasToEditOwnerTaxId" class="offline-user-detail">
            *ต้องแก้ไขเลขประจำตัวผู้เสียภาษีก่อนส่ง eztax
          </div>
        </div>
        <div v-if="!isEditTaxId" class="text mb-4 mt-2">
          <button
            v-if="!isHiddenDrecryptButton"
            class="button-content"
            @click="handleDecryptTaxId"
          >
            <span style="font-weight: bold">แสดงข้อมูล</span>
            <i class="fa fa-eye-slash" aria-hidden="true"></i>
          </button>
          <div v-if="receipt.client.taxId" class="identifier-id">
            {{ receipt.client.taxId }}
          </div>
        </div>
        <div v-else class="text mb-4">{{ form.taxId }}</div>
        <sc-button
          v-if="!hasBranchNumber"
          :disabled="canNotEditAddress || isViewOnlyByRole"
          :hidden=!receipt.invoiceId
          variant="primary"
          size="sm"
          @click="handleClickAddBranchNumberButton"
        >เพิ่มเลขสาขา</sc-button>
        <div v-else>
          <div class="label">
            เลขสาขา
            <sc-button
              :disabled="canNotEditAddress"
              variant="secondary"
              size="sm"
              @click="handleClickEditBranchNumberButton"
            >แก้ไขเลขสาขา</sc-button>
          </div>
          <div class="text mb-4">{{ form.branchNumber }}</div>
        </div>
      </div>
      <hr />
      <div class="mb-3">
        <div class="row">
          <div class="col col-lg-3">
            <div class="label">รายการ</div>
              <router-link
                v-if="receipt.item.subscriptionId"
                :to="{
                  name: 'SubscriberDetailPage',
                  params: { id: receipt.item.subscriptionId },
                }"
                target="_blank"
              >{{ receipt.item.name }}</router-link>
            <div v-else class="text">{{ receipt.item.name }}</div>
          </div>
          <div class="col col-lg-4">
            <div class="label">อายุการใช้งาน</div>
            <div class="text">{{ receipt.item.duration }}</div>
          </div>
          <div class="col col-lg-2">
            <div class="label">จำนวนแพ็กเกจ</div>
            <div class="text">{{ receipt.item.quantity }}</div>
          </div>
          <div class="col col-lg-3 text-end">
            <div class="label">ราคา</div>
            <div class="text">{{ receipt.item.price }}</div>
          </div>
        </div>
      </div>
      <hr />
      <div v-for="item in itemPresenters" :key="item.id">
        <div class="mb-3">
          <div class="row">
            <div class="col col-lg-8">
              <div class="text">{{ item.title }}</div>
            </div>
            <div class="col col-lg-4 text-end">
              <div class="text">{{ item.amount }}</div>
            </div>
          </div>
        </div>
        <hr />
      </div>
      <div class="text-end">
        <div v-show="isCreditNote" class="mb-3">
          <div class="label">จำนวนเงินก่อนภาษีตามเอกสารเดิม</div>
          <div class="text">{{ receipt.summary.referenceBasisAmount }}</div>
          <hr />
        </div>
        <div class="mb-3">
          <div class="label">จำนวนเงินก่อนภาษีที่ถูกต้อง</div>
          <div class="text">{{ receipt.summary.amountBeforeVat }}</div>
        </div>
        <hr />
        <div v-show="isCreditNote" class="mb-3">
          <div class="label">ผลต่างจำนวนเงินก่อนภาษี</div>
          <div class="text">{{ receipt.summary.differenceBasisAmount }}</div>
          <hr />
        </div>
        <div class="mb-3">
          <div class="label">ภาษีมูลค่าเพิ่ม (7%)</div>
          <div class="text">{{ receipt.summary.vat }}</div>
        </div>
        <hr />
        <div class="mb-3">
          <div class="label">จำนวนเงินรวมทั้งสิ้น</div>
          <div class="text">{{ receipt.summary.grandTotal }}</div>
        </div>
      </div>
      <div>
        <div class="actions text-end">
          <sc-button
            v-if="hasBranchNumber"
            variant="secondary"
            class="mb-4"
            @click="handleClickAddSelectWithholdingAlbumDialog"
          >ใบหัก ณ ที่จ่าย</sc-button>
          <sc-button
            v-if="(
              showConfirmReceiptButton
              || showSendReceiptButton
              || receipt.isOfflineReceipt
            ) && !isViewOnlyByRole"
            variant="warning"
            class="mb-4"
            @click="handleClickAddOfflinePdfReceiptButton"
          >ออกใบเสร็จนอกระบบ</sc-button>
          <sc-button
            v-if="showDeletePreviewReceiptButton && showConfirmReceiptButton && !isViewOnlyByRole"
            variant="danger"
            class="mb-4"
            @click="handleClickDeleteReceiptButton"
          >ลบตัวอย่างใบเสร็จนี้</sc-button>
          <a
            v-if="showPreviewReceiptButton && (showSendReceiptButton || showConfirmReceiptButton)"
            class="preview mb-4"
            :class="{ disabled: isPreviewLoading }"
            target="_blank"
            @click.prevent="!isPreviewLoading && handlePreviewReceipt(
              receipt.pdfUrl,
              selectedLanguage.value
            )"
            >{{ isPreviewLoading ? "กำลังโหลด..." : "ดูตัวอย่างใบเสร็จ" }}</a
          >
          <el-dialog
            :visible.sync="showErrorDialog"
            :modal="false"
            :append-to-body="true"
            title="Validation Error"
            width="40%"
            @close="showErrorDialog = false"
          >
            <span>{{ nameError }}</span>
            <span slot="footer" class="dialog-footer">
              <el-button @click="showErrorDialog = false">OK</el-button>
            </span>
          </el-dialog>
          <div v-if="!receipt.isDuplicateReceiptByInvoice">
            <sc-button
              v-if="showSendReceiptButton"
              :disabled="
                isSending
                || isHasToEditOwnerName
                || isHasToEditOwnerTaxId
                || isViewOnlyByRole
                || isBlockSendReceiptByHalfHourFirst
              "
              variant="primary"
              @click="handleClickSendReceiptButton('SEND')"
              >ส่ง EZTax</sc-button
            >
            <sc-button
              v-else-if="showConfirmReceiptButton"
              :disabled="
                isSending
                || isHasToEditOwnerName
                || isHasToEditOwnerTaxId
                || isViewOnlyByRole
                || isBlockSendReceiptByHalfHourFirst
              "
              variant="secondary"
              @click="handleClickSendReceiptButton('CONFIRM')"
            >ยืนยันข้อมูล</sc-button>
            <div
v-else-if="isSuccessToSentEztax"
              class="text-end"
              >ส่งใบเสร็จให้ EZTax แล้ว
            </div>
            <div
              v-else
              class="text-end"
            >
              ไม่พบสถานะปัจจุบัน (กรุณาติดต่อ TS)
            </div>
            <div v-if="isBlockSendReceiptByHalfHourFirst" class="text-end">
              ปิดไม่ให้ส่งใบเสร็จในครึ่งชั่วโมงแรก 00.00 - 00.30 นาที
            </div>
          </div>
          <div v-if="receipt.isDuplicateReceiptByInvoice" class="offline-user-detail">
            ไม่สามารถส่ง EZTax ได้ เพราะเลขที่ใบเสร็จซ้ำ หรือ เลขที่ invoice ซ้ำ (กรุณาติดต่อ TS)
          </div>
        </div>
        <div v-if="receipt.isOfflineReceipt && !receipt.fileOfflinePdfKey" class="text-end">ออกใบเสร็จนอกระบบแล้ว</div>
        <div v-else-if="receipt.isOfflineReceipt && fileOfflinePdfUrl" class="text-end">
          <a
            :href="fileOfflinePdfUrl"
            class="pointer"
            target="_blank"
            >ออกใบเสร็จนอกระบบแล้ว
          </a>
        </div>
      </div>
      <confirm-dialog
        v-if="issuedAtDialog.isShow"
        :data="issuedAtDialog"
        @confirm="(isConfirm) => handleConfirmIssuedAt(isConfirm)"
      >
        <div class="text-start mb-4">
          <div class="label">วันที่จากระบบ</div>
          <div class="text">{{ receipt.createdDate }}</div>
        </div>
        <div class="text-start">
          <div class="label">วันที่ใหม่</div>
          <date-picker v-model="form.tempIssuedAt" type="date" format="dd/MM/yyyy"></date-picker>
          <p
            v-if="!form.tempIssuedAt"
            style="color: red; font-size: 12px"
          >
            กรุณาเลือกวันที่
          </p>
        </div>
      </confirm-dialog>
      <confirm-dialog
        v-if="confirmDialog.isShow"
        :data="confirmDialog"
        @confirm="(isConfirm) => handleConfirm(isConfirm)"
      >
        <div class="text-start mb-4">
          <div class="label">ชื่อจากระบบ</div>
          <div class="text">{{ receipt.client.name }}</div>
        </div>
        <div class="text-start">
          <div class="label">ชื่อใหม่</div>
          <el-input v-model="form.tempName" class="name"></el-input>
          <p
            v-if="!form.tempName"
            style="color: red; font-size: 12px"
          >
            กรุณาใส่ชื่อลูกค้า
          </p>
        </div>
      </confirm-dialog>
      <confirm-dialog
        v-if="addressDialog.isShow"
        :data="addressDialog"
        @confirm="(isConfirm) => handleConfirmAddress(isConfirm)"
      >
        <div class="text-start">
          <div class="label mb-2" style="font-weight: 600;">เลือกประเภทของที่อยู่</div>
          <div class="address-options">
            <el-radio
              v-for="address in addressOptions"
              :key="address.value"
              v-model="selectedAddress.temp"
              :label="address.value"
            >
              {{ address.label }}
            </el-radio>
          </div>
        </div>
        <div v-if="isTempIntlAddressSelected" class="text-start mt-2 mb-2">
          <div class="label mb-2">ที่อยู่</div>
          <el-input
            v-model="addressForm.intlAddress"
            type="textarea"
            placeholder="ระบุที่อยู่"
            autocomplete="off"
            clearable
            @input="validateAddressForm($event, true)"
          />
            <p
              v-if="intlAddressError"
              class="mt-1"
              style="color: red;
              font-size: 12px"
            >
            {{ intlAddressError }}
          </p>
        </div>
        <div v-if="isTempIntlAddressSelected" class="text-start mb-2">
          <country-selector
            :country-options="countryOptions"
            :code="addressForm.countryCode"
            @countrySelected="handleCountrySelected"
          ></country-selector>
        </div>
        <div v-if="!isTempIntlAddressSelected" class="text-start mt-3 mb-2">
          <div class="label mb-2">ที่อยู่</div>
          <el-input
            v-model="addressForm.address"
            @input="validateAddressForm($event)"
          >
          </el-input>
          <p
            v-if="addressError"
            style="color: red;
            font-size: 12px"
          >
            {{ addressError }}
          </p>
        </div>
        <div v-if="!isTempIntlAddressSelected" class="text-start mb-2">
          <div class="label mb-2">รหัสไปรษณีย์</div>
          <el-select
            :value="addressForm.zip_code"
            :remote-method="handleSearchZipCode"
            clearable
            filterable
            remote
            @input="handleChangeAddressForm('zip_code', $event)"
          >
            <el-option v-for="code in zipCodes" :key="code" :value="code">{{
              code
            }}</el-option>
          </el-select>
          <p
            v-if="!addressForm.zip_code"
            style="color: red; font-size: 12px"
          >
            กรุณาใส่รหัสไปรษณีย์
          </p>
        </div>
        <div v-if="!isTempIntlAddressSelected" class="text-start mb-2">
          <div class="label mb-2">จังหวัด</div>
          <el-select
            :value="addressForm.province_code"
            filterable
            value-key="province_code"
            label-key="provice_name"
            @input="handleChangeAddressForm('province_code', $event)"
          >
            <el-option
              v-for="p in provinces"
              :key="p.province_code"
              :value="p.province_code"
              :label="isEnglish ? p.province_name_en : p.province_name"
              >{{ isEnglish ? p.province_name_en : p.province_name }}</el-option
            >
          </el-select>
          <p
            v-if="!addressForm.province_code"
            style="color: red; font-size: 12px"
          >
            กรุณาใส่จังหวัด
          </p>
        </div>
        <div v-if="!isTempIntlAddressSelected" class="text-start mb-2">
          <div class="label mb-2">อำเภอ</div>
          <el-select
            :value="addressForm.amphur_code"
            filterable
            @input="handleChangeAddressForm('amphur_code', $event)"
          >
            <el-option
              v-for="a in amphurs"
              :key="a.amphur_code"
              :value="a.amphur_code"
              :label="isEnglish ? a.amphur_name_en : a.amphur_name"
              >{{ isEnglish ? a.amphur_name_en : a.amphur_name }}</el-option
            >
          </el-select>
          <p
            v-if="!addressForm.amphur_code"
            style="color: red; font-size: 12px"
          >
            กรุณาใส่อำเภอ
          </p>
        </div>
        <div v-if="!isTempIntlAddressSelected" class="text-start">
          <div class="label mb-2">ตำบล</div>
          <el-select
            v-model="addressForm.tumbon"
            :value="addressForm.tumbon"
            filterable
            value-key="tumbon_code"
            label-key="tumbon_name"
            @input="handleChangeAddressForm('tumbon', $event)"
          >
            <el-option
              v-for="t in selectableTumbons"
              :key="t.tumbon_code"
              :value="t"
              :label="isEnglish ? t.tumbon_name_en : t.tumbon_name"
              >{{ isEnglish ? t.tumbon_name_en : t.tumbon_name }}</el-option
            >
          </el-select>
          <p
            v-if="!addressForm.tumbon"
            style="color: red; font-size: 12px"
          >
            กรุณาใส่ตำบล
          </p>
        </div>
      </confirm-dialog>
      <confirm-dialog
        v-if="taxIdDialog.isShow"
        :data="taxIdDialog"
        @confirm="(isConfirm) => handleConfirmTaxId(isConfirm)"
      >
        <div class="text-start mb-4">
          <div class="label">เลขประจำตัวผู้เสียภาษีจากระบบ</div>
          <div v-if="!isEditTaxId" class="text mb-4">
          <button
            v-if="!isHiddenDrecryptButton"
            class="button-content"
            @click="handleDecryptTaxId"
          >
            <span style="font-weight: bold">แสดงข้อมูล</span>
            <i class="fa fa-eye-slash" aria-hidden="true"></i>
          </button>
          <div v-if="receipt.client.taxId" class="identifier-id">
            {{ receipt.client.taxId }}
          </div>
         </div>
        </div>
        <div class="text-start">
          <div class="label">เลขประจำตัวผู้เสียภาษีใหม่</div>
          <el-input
            v-model="form.tempTaxId"
            class="name"
            @input="form.tempTaxId = form.tempTaxId.replace(/[^A-Z0-9]/g, '')"
          ></el-input>
        </div>
        <p
            v-if="!form.tempTaxId"
            style="color: red; font-size: 12px"
          >
            กรุณาใส่เลขประจำตัวผู้เสียภาษี
          </p>
      </confirm-dialog>
      <confirm-dialog
        v-if="confirmDeleteReceiptDialog.isShow"
        :data="confirmDeleteReceiptDialog"
        @confirm="handleConfirmCancel"
      >
        <div class="text-center">
          <div class="text-start">
            <div class="label mb-2">เหตุผลในการลบตัวอย่างใบเสร็จ</div>
            <el-input v-model="receiptDeleteReason" class="name"></el-input>
          </div>
        </div>
      </confirm-dialog>
      <confirm-dialog
        v-if="addBranchNumberDialog.isShow"
        :data="addBranchNumberDialog"
        @confirm="handleConfirmAddBranchNumber"
      >
        <div class="text-center">
          <el-input
            v-model="form.tempBranchNumber"
            placeholder="00000"
            class="branch-number"
            maxlength="5"
            type="number"
          ></el-input>
        </div>
      </confirm-dialog>
      <confirm-dialog
        v-if="editBranchNumberDialog.isShow"
        :data="editBranchNumberDialog"
        @confirm="(isConfirm) => handleConfirmEditBranchNumber(isConfirm)"
      >
        <div class="text-center">
          <el-input
            v-model="form.tempBranchNumber"
            placeholder="00000"
            class="branch-number"
            maxlength="5"
            type="number"
          ></el-input>
          <p
            v-if="!form.tempBranchNumber"
            style="color: red; font-size: 12px"
          >
            กรุณาใส่เลขสาขา
          </p>
        </div>
      </confirm-dialog>
      <pdf-picker-modal
        v-bind="selectPdfDialog"
        @cancel="handleCancelSelectPdfDialog"
        @confirm="handleConfirmSelectPdfDialog($event)"
        @fileNotChanged="handleFileNotChangedPdfDialog"
      ></pdf-picker-modal>
      <album-and-swipe-picker
        v-bind="selectWithholdingImageAlbumDialog"
        @cancel="handleCancelSelectWithholdingAlbumDialog"
        @confirm="handleConfirmSelectWithholdingAlbumDialog($event)"
    ></album-and-swipe-picker>
    </div>
  </page-wrapper>
</template>

<script>
import ConfirmDialog from "@/components/helper/dialog/ConfirmDialog";
import { baanRueJaiClient, backendAdminClient } from "@/dependencies";
import { getPDF, uploadPublicFile } from "@/god";
import AlbumAndSwipePicker from "@/lib/components/AlbumAndSwipePicker";
import DatePicker from "@/lib/components/DatePicker";
import PageWrapper from "@/lib/components/PageWrapper";
import PdfPickerModal from "@/lib/components/PdfPickerModal";
import ScButton from "@/lib/components/ScButton";
import { localization, receiptTypeTH } from "@/lib/mapper";
import { existValueAndEmptyString, getKeyByUrlPath, isValidReceiptUserName } from "@/lib/util";

import {
  Input as ElInput,
  Option as ElOption,
  Select as ElSelect,
  MessageBox
} from "element-ui";
import { DateTime } from "luxon";
import * as R from "ramda";
import { getAdminRolePermission } from "../adminRolePermission";

import CountrySelector from "../../../../../lib/components/CountrySelector";
import { getCountries, getCountryByCode } from "../../../../../lib/country";

export default {
  components: {
    PageWrapper,
    ScButton,
    ConfirmDialog,
    ElInput,
    ElSelect,
    ElOption,
    DatePicker,
    PdfPickerModal,
    "album-and-swipe-picker": AlbumAndSwipePicker,
    CountrySelector
  },
  data() {
    const title = "ข้อมูลใบเสร็จ";
    const form = {
      name: "",
      tempName: "",
      taxId: "",
      tempTaxId: "",
      branchNumber: "",
      tempBranchNumber: "",
      issuedAt: DateTime.utc(),
      tempIssuedAt: DateTime.utc(),
      receiptDeleteReason: "",
    };
    const issuedAtDialog = {
      isShow: false,
      title: "เปลี่ยนแปลงวันที่",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก",
      disableSubmit: false,
    };
    const addBranchNumberDialog = {
      isShow: false,
      title: "เพิ่มเลขสาขา",
      subTitle: "ระบุเลขสาขาด้วยตัวเลข 5 หลัก กรณีที่เป็นสำนักงานใหญ่ให้ระบุเป็น 00000",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก"
    };
    const editBranchNumberDialog = {
      isShow: false,
      title: "เปลี่ยนเลขสาขา",
      subTitle: `ระบุเลขสาขาด้วยตัวเลข 5 หลัก กรณีที่เป็นสำนักงานใหญ่ให้ระบุเป็น 00000`,
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก",
      disableSubmit: false
    };
    const confirmDialog = {
      isShow: false,
      title: "เปลี่ยนแปลงชื่อลูกค้า",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก",
      disableSubmit: false,
    };
    const addressDialog = {
      isShow: false,
      title: "เปลี่ยนแปลงที่อยู่",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก",
      disableSubmit: false,
    };
    const taxIdDialog = {
      isShow: false,
      title: "เปลี่ยนแปลงเลขประจำตัวผู้เสียภาษี",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "บันทึก",
      disableSubmit: false,
    }
    const confirmDeleteReceiptDialog = {
      isShow: false,
      title: "ยืนยันการลบตัวอย่างใบเสร็จ",
      buttonCancel: "ยกเลิก",
      buttonSubmit: "ยืนยัน",
    };
    const addressForm = {
      zip_code: null,
      province_code: null,
      amphur_code: null,
      tumbon: null,
      address: null,
      intlAddress: null,
      countryCode: null,
      countryName: null,
    };
    const tempAddressForm = {
      zip_code: null,
      province_code: null,
      amphur_code: null,
      tumbon: null,
      address: null,
      intlAddress: null,
      countryCode: null,
      countryName: null,
    };

    const permission = getAdminRolePermission();

    const languageOptions = [
      {
        label: "ไทย",
        value: localization.TH,
        icon: "/static/icons/language-th-icon.svg",
      },
      {
        label: "English",
        value: localization.EN,
        icon: "/static/icons/language-en-icon.svg",
      }
    ]

    const addressOptions = [
      { label: "ที่อยู่ภายในประเทศ", value: "DOMESTIC" },
      { label: "ที่อยู่ต่างประเทศ", value: "INTERNATIONAL" }
    ];

    const selectedAddress = {
      current: null,
      temp: null,
      value: null
    };

    return {
      title,
      rawReceipt: null,
      isSending: false,
      form,
      issuedAtDialog,
      addBranchNumberDialog,
      editBranchNumberDialog,
      confirmDialog,
      addressDialog,
      taxIdDialog,
      confirmDeleteReceiptDialog,
      addressForm,
      tempAddressForm,
      clientAddressForm: null,
      firstRun: true,
      initialTumbons: [],
      searchTumbons: null,
      receiptDeleteReason: "",
      isShowSelectPdfDialog: false,
      fileOfflinePdfUrl: null,
      isShowSelectWithholdingImageAlbum: false,
      withholdingTaxKeyAlbum: [],
      canNotEditAddress: false,
      permission,
      showErrorDialog: false,
      nameError: '',
      languageOptions,
      selectedLanguage: null,
      addressOptions,
      selectedAddress,
      addressError: '',
      intlAddressError: '',
      countryOptions: getCountries(),
      decryptedId: null,
      isHiddenDrecryptButton: false,
      isPreviewLoading: false
    };
  },
  computed: {
    isEditTaxId() {
      return (
        !R.isEmpty(this.form.taxId) &&
        this.form.taxId !== this.rawReceipt.tax_id_field
      );
    },
    itemPresenters() {
      if (!this.rawReceipt) {
        return [];
      }

      return this.rawReceipt.items.slice(1);
    },
    tumbons() {
      return this.searchTumbons || this.initialTumbons;
    },
    receipt() {
      if (!this.rawReceipt) {
        return null;
      }

      const no = this.rawReceipt.is_offline_receipt
        ? 'ใบเสร็จนอกระบบ'
        : this.rawReceipt.id;
      const createdDate = DateTime.fromISO(this.rawReceipt.created_date)
        .setZone("utc+7")
        .setLocale("th")
        .toFormat("dd/MM/yyyy");
      const issuedAt = this.form.issuedAt
        .setZone("utc+7")
        .setLocale("th")
        .toFormat("dd/MM/yyyy");

      const line1 = this.createAddressLine1();
      const line2 = this.createAddressLine2();

      const client = {
        name: this.rawReceipt.name,
        addressLine1: line1,
        addressLine2: line2,
        taxId: this.rawReceipt.tax_id_field
      };

      const price = this.rawReceipt.items
        && this.rawReceipt.items.length > 0
        && this.rawReceipt.items[0].amount
        ? this.rawReceipt.items[0].amount
        : undefined

      const packageName = this.isEnglish
        ? this.rawReceipt.package_name_en
        : this.rawReceipt.package_name;

      const item = {
        name: packageName,
        duration: this.rawReceipt.package_duration,
        price,
        quantity: this.rawReceipt.quantity,
        subscriptionId: this.rawReceipt.subscription_id
      };
      const summary = {
        referenceBasisAmount: this.rawReceipt.reference_basis_amount
          ? this.rawReceipt.reference_basis_amount
          : null,
        amountBeforeVat: this.rawReceipt.basis_price,
        differenceBasisAmount: this.rawReceipt.difference_basis_amount
          ? this.rawReceipt.difference_basis_amount
          : null,
        vat: this.rawReceipt.tax,
        grandTotal: this.rawReceipt.total_amount
      };

      let pdfUrl = this.rawReceipt.pdf_url;

      if (this.form.issuedAt) {
        pdfUrl += `&issued_at=${  encodeURIComponent(this.form.issuedAt.toISO())}`;
      }

      if (this.form.name) {
        pdfUrl += `&name=${  encodeURI(this.form.name)}`;
      }

      const taxId = this.isEditTaxId ? this.form.taxId : this.rawReceipt.tax_id_field;

      pdfUrl += `&line1=${  encodeURI(line1)}`;
      pdfUrl += `&tax_id=${  encodeURI(taxId)}`;

      if (line2 && line2 !== "") {
        const line2SplitArray = line2.split(" ");
        pdfUrl += `&zip_code=${  encodeURI(line2SplitArray[line2SplitArray.length - 1])}`;

        line2SplitArray.pop();
        pdfUrl += `&line2=${  encodeURI(line2SplitArray.join(" "))}`;
      }

      if (this.hasBranchNumber) {
        pdfUrl += `&branch_number=${  encodeURI(this.form.branchNumber)}`;
      }

      const purpose = this.rawReceipt.purpose ?? null;
      const referenceDocumentNumber = this.rawReceipt.reference_document_number ?? null;
      const invoiceId = this.rawReceipt.invoice_id ?? null;

      const {
        seller_trade_party_name: sellerTradePartyNameTh,
        seller_trade_party_name_en: sellerTradePartyNameEn
      } = this.rawReceipt;
      const sellerTradePartyName = this.isEnglish
        ? sellerTradePartyNameEn
        : sellerTradePartyNameTh;

      return {
        no,
        createdDate,
        issuedAt,
        client,
        item,
        summary,
        pdfUrl,
        purpose,
        referenceDocumentNumber,
        sellerTradePartyName,
        invoiceId,
        type: receiptTypeTH[this.rawReceipt.type],
        canDelete: this.rawReceipt.can_delete,
        canSendToEztax: this.rawReceipt.can_send_to_eztax,
        canResendToEztax: this.rawReceipt.can_resend_to_eztax,
        fileOfflineName: this.rawReceipt.offline_pdf_name || null,
        fileOfflinePdfKey: this.rawReceipt.offline_pdf_key || null,
        isOfflineReceipt: this.rawReceipt.is_offline_receipt || null,
        isDuplicateReceiptByInvoice: this.rawReceipt.is_duplicate_receipt_by_invoice || false,
        isManualPayment: this.rawReceipt.is_manual_payment || false,
        isNonVerifySales: this.rawReceipt.is_non_verify_sales || false,
      };
    },
    showPreviewReceiptButton() {
      return !this.rawReceipt.appointment_no
    },
    showDeletePreviewReceiptButton() {
      return this.rawReceipt.can_delete
    },
    showSendReceiptButton() {
      return (this.rawReceipt.can_send_to_eztax || this.rawReceipt.can_resend_to_eztax)
    },
    showConfirmReceiptButton() {
      return this.rawReceipt.can_confirm
    },
    isSuccessToSentEztax() {
      return this.rawReceipt.is_success_to_send_eztax
    },
    zipCodes() {
      if (!this.tumbons.length) {
        return [];
      }

      return R.pipe(R.map(R.path(["zip_code"])), R.uniq)(this.tumbons);
    },
    provinces() {
      return R.uniqBy(R.path(["province_code"]),
      this.tumbons.filter(item => item.zip_code === this.addressForm.zip_code));
    },
    amphurs() {
      if (!this.addressForm.province_code) {
        return [];
      }

      return R.pipe(
        R.filter(R.propEq(this.addressForm.province_code, "province_code")),
        R.uniqBy(R.path(["amphur_code"]))
      )(this.tumbons.filter(item => item.zip_code === this.addressForm.zip_code));
    },
    selectableTumbons() {
      if (!this.addressForm.amphur_code) {
        return [];
      }

      return this.tumbons.filter(({ amphur_code: amphurCode, zip_code: zipCode }) => (
          amphurCode === this.addressForm.amphur_code &&
          zipCode === this.addressForm.zip_code
        ));
    },
    isCreditNote() {
      return this.receipt.type === receiptTypeTH.CREDIT_NOTE;
    },
    hasBranchNumber() {
      return !R.isEmpty(this.form.branchNumber);
    },
    selectPdfDialog() {
      return {
        isShow: this.isShowSelectPdfDialog,
        title: "เลือก PDF",
        isLoading: false,
        fileName: this.receipt.fileOfflineName
      }
    },
    isHasToEditOwnerName() {
      return this.rawReceipt.has_edited_owner_name === false
        && this.form.name === this.receipt.client.name
        && this.rawReceipt.is_user_for_offline_purchase_by_admin === true
    },
    isHasToEditOwnerTaxId() {
      return this.rawReceipt.has_edited_owner_tax_id === false
        && this.form.taxId === this.receipt.client.taxId
        && this.rawReceipt.is_user_for_offline_purchase_by_admin === true
    },
    isOfflineUser() {
      return this.rawReceipt.is_user_for_offline_purchase_by_admin
    },
    selectWithholdingImageAlbumDialog() {
      return {
        isShow: this.isShowSelectWithholdingImageAlbum,
        title: "Withholding Tax Album",
        album: this.isShowSelectWithholdingImageAlbum
          ? this.rawReceipt.withholding_images
          : undefined,
        canEdit: true,
        imageName: "withholding_tax",
        titleForChooseImage: "เลือกรูป หัก ณ ที่จ่าย",
        pathImage: "withholding_tax",
        isNotMakePublicImage: true
      };
    },
    isViewOnlyByRole() {
      const roles = ["AC"]
      return !!this.permission && roles.includes(this.permission.role)
    },
    isBlockSendReceiptByHalfHourFirst() {
      const currentTime = new Date();
      const minutes = currentTime.getMinutes();

      return minutes >= 0 && minutes < 30;
    },
    isEnglish() {
      return this.selectedLanguage && this.selectedLanguage.value === localization.EN || false;
    },
    isIntlAddressSelected() {
      return this.selectedAddress.value === this.getAddressType(1);
    },
    isTempIntlAddressSelected() {
      return this.selectedAddress.temp === this.getAddressType(1);
    },
  },
  watch: {
    "form.tempIssuedAt": function watchTempIssuedAt(val) {
      this.issuedAtDialog.disableSubmit = !val;
    },
    "form.tempName": function watchTempName(val) {
      this.confirmDialog.disableSubmit = !val;
    },
    "form.tempTaxId": function watchTempTaxId(val) {
      this.taxIdDialog.disableSubmit = !val;
    },
    "form.tempBranchNumber": function watchTempBranchNumber(val) {
      this.editBranchNumberDialog.disableSubmit = !val;
    },
    "addressForm.zip_code": function watchAddressZipCode(val) {
      this.addressDialog.disableSubmit = !val;
    },
    "addressForm.province_code": function watchAddressProvinceCode(val) {
      this.addressDialog.disableSubmit = !val;
    },
    "addressForm.amphur_code": function watchAddressAmphurCode(val) {
      this.addressDialog.disableSubmit = !val;
    },
    "addressForm.tumbon": function watchAddressTumbon(val) {
      this.addressDialog.disableSubmit = !val;
    },
    "addressForm.address": function watchAddressAddress(val) {
      this.addressDialog.disableSubmit = !val;
    },
    "addressForm.intlAddress": function watchAddressIntlAddress(val) {
      this.addressDialog.disableSubmit = !val;
    },
    "addressForm.countryCode": function watchAddressCountryCode(val) {
      this.addressDialog.disableSubmit = !val;
    },
    "selectedAddress.temp": async function watchSelectedAddressTemp() {
      await this.validateSelectedAddress(this.addressForm, this.isIntlAddressSelected);
    },
    "selectedLanguage.value": async function watchSelectedLanguageValue() {
      if (this.firstRun) return;

      this.addressForm = {
        ...this.addressForm,
        language: this.getLangCode()
      };

      await this.validateSelectedAddress(this.addressForm, this.isIntlAddressSelected);
      await this.updateReceiptAddress(this.addressForm);
    },
  },
  created() {
    this.setup();
  },
  methods: {
    getRouteReceiptId() {
      const { id } = this.$route.params;
      if (!id) {
        this.$message.error("ไม่พบรหัสใบเสร็จ");
        return null;
      }

      return id;
    },
    isInFirstHalfHourNow() {
      const minutes = new Date().getMinutes();
      return minutes >= 0 && minutes < 30;
    },
    markPendingConfirm() {
      this.rawReceipt.can_confirm = true;
      this.rawReceipt.can_send_to_eztax = false;
      this.rawReceipt.can_resend_to_eztax = false;
      this.isHiddenDrecryptButton = false;
    },
    async setup() {
      this.firstRun = true;
      await this.setupData();
      if (!this.rawReceipt) {
        return;
      }
      await this.setupForm();
      // ใช้ $nextTick เพื่อให้ watcher ที่ queue ไว้ตอน setupLanguage วิ่งก่อน แล้วค่อยปลด flag
      this.$nextTick(() => {
        this.firstRun = false;
      });
    },
    async setupData() {
      await this.setupRawReceipt();
      if (!this.rawReceipt) {
        return;
      }
      await this.setupInitialTumbons();
    },
    async setupRawReceipt() {
      const result = await this.fetchData();
      if (!result) {
        return;
      }

      this.setupLanguage(result.address);

      this.rawReceipt = result;

      const offlinePdfKey = result.offline_pdf_key
        ? await getPDF(result.offline_pdf_key, "receipt")
        : null;

      this.fileOfflinePdfUrl = offlinePdfKey;
    },
    async setupInitialTumbons() {
      const zipCode = this.rawReceipt.address ? this.rawReceipt.address.zip_code : this.rawReceipt.home.zip_code;
      const params = { zip_code: zipCode };
      const response = await baanRueJaiClient.admin.addresses.list(params);

      this.initialTumbons = response.data.result;
    },
    getDefaultLanguage(language) {
      const defaultLanguage = language && language === "en"
        ? localization.EN
        : localization.TH;

      return defaultLanguage;
    },
    async setupLanguage(address) {
      const defaultLanguage = this.getDefaultLangOrFallback(address);

      this.selectedLanguage =
        this.languageOptions.find(language => language.value === defaultLanguage);
    },
    getDefaultLangOrFallback(address) {
      return address ? this.getDefaultLanguage(address.language) : localization.TH;
    },
    async setupForm() {
      this.setupIssuedAtForm();
      this.setupNameAndTaxIdForm();
      this.setupBranchNumber();
      this.setupAddressForm();
    },
    setupIssuedAtForm() {
      const issuedAt = this.rawReceipt.issued_at
        ? DateTime.fromISO(this.rawReceipt.issued_at)
        : DateTime.fromISO(this.rawReceipt.created_date);

      this.form.issuedAt = issuedAt;
      this.form.tempIssuedAt = issuedAt;
    },
    setupNameAndTaxIdForm() {
      this.form.name = this.receipt.client.name.trim();
      this.form.tempName = this.form.name;
      this.form.taxId = this.receipt.client.taxId
      this.form.tempTaxId = this.receipt.client.taxId
    },
    setupAddressForm() {
      const userTaxInvoice = this.rawReceipt.user_tax_invoice || undefined

      this.canNotEditAddress = userTaxInvoice
        && this.rawReceipt.can_resend_to_eztax
        && this.rawReceipt.can_resend_to_eztax === true

      const { home, address } = this.rawReceipt;
      const {
        zip_code: rawZipCode,
        province_name: rawProvinceName,
        amphur_name: rawAmphurName,
        tumbon_name: rawTumbonName,
        international_address: intlAddress,
        country_code: countryCode,
        country_name: countryName
      } = address || home;


      const zipCode = userTaxInvoice ? userTaxInvoice.zip_code : rawZipCode
      const provinceName = userTaxInvoice ? userTaxInvoice.province : rawProvinceName
      const amphurName = userTaxInvoice ? userTaxInvoice.amphur : rawAmphurName
      const tumbonName = userTaxInvoice ? userTaxInvoice.tumbon : rawTumbonName

      // Set default address type
      const domesticAddressType = this.getAddressType(0);
      const intlAddressType = this.getAddressType(1);
      const currentAddress = intlAddress
        ? intlAddressType
        : domesticAddressType;

      this.selectedAddress = {
        current: currentAddress,
        temp: currentAddress,
        value: currentAddress
      };

      // Set default address form
      const isTumbonsNotEmpty = this.tumbons && this.tumbons.length > 0;
      const matchedProvince = isTumbonsNotEmpty
        ? this.tumbons.find(t => t.province_name === provinceName)
        : null;
      const defaultProvinceCode = matchedProvince ? matchedProvince.province_code : null;
      const matchedAmphur = isTumbonsNotEmpty
        ? this.tumbons.find(t => t.amphur_name === amphurName)
        : null;
      const defaultAmphurCode = matchedAmphur ? matchedAmphur.amphur_code : null;
      const defaultTumbon = isTumbonsNotEmpty
        ? this.tumbons.find(t => t.tumbon_name === tumbonName) || null
        : null;
      const defaultAddress = address && address.address
        ? address.address
        : this.rawReceipt.line_one;
      const defaultIntlAddress = intlAddress || null;

      this.addressForm = {
        zip_code: zipCode,
        province_code: defaultProvinceCode,
        amphur_code: defaultAmphurCode,
        tumbon: defaultTumbon,
        address: defaultAddress,
        intlAddress: defaultIntlAddress,
        countryCode,
        countryName
      };

      this.tempAddressForm = {
        zip_code: zipCode,
        province_code: defaultProvinceCode,
        amphur_code: defaultAmphurCode,
        tumbon: defaultTumbon,
        address: defaultAddress,
        intlAddress: defaultIntlAddress,
        countryCode,
        countryName
      };

      // Set address error
      this.addressError = !defaultAddress ? 'กรุณาใส่ที่อยู่' : '';
      this.intlAddressError = !defaultIntlAddress ? 'กรุณาใส่ที่อยู่' : '';
    },
    setupBranchNumber() {
      let currentBranchNumber = ""
      const hasUserTaxBranchNo = this.rawReceipt.user_tax_invoice
        && this.rawReceipt.user_tax_invoice.branch_no

      if (hasUserTaxBranchNo && !this.rawReceipt.receipt_billing_address) {
        // Override: ใช้เลขสาขาจาก user_tax_invoice เมื่อยังไม่มี receipt_billing_address
        currentBranchNumber = this.rawReceipt.user_tax_invoice.branch_no
      } else if (existValueAndEmptyString(this.rawReceipt.branch_number)) {
        currentBranchNumber = this.rawReceipt.branch_number
      } else if (
        this.rawReceipt.user_tax_invoice
        && existValueAndEmptyString(this.rawReceipt.user_tax_invoice.branch_no)
      ) {
        currentBranchNumber = this.rawReceipt.user_tax_invoice.branch_no
      }

      this.form.branchNumber = currentBranchNumber;
      this.form.tempBranchNumber = currentBranchNumber;
    },
    async fetchData() {
      const id = this.getRouteReceiptId();
      if (!id) {
        return null;
      }

      const response = await baanRueJaiClient.admin.subscriptions.receipts.get(
        id
      );

      return response.data.result;
    },
    async handlePreviewReceipt(url, language, hasRetried = false) {
      this.isPreviewLoading = true;

      try {
        const response = await baanRueJaiClient.admin.subscriptions.receipts.previewPdf(
          url,
          language
        );

        const blob = new Blob([response.data], { type: 'application/pdf' });
        const blobUrl = window.URL.createObjectURL(blob);

        window.open(blobUrl, '_blank');
      } catch (error) {
        let errorMessage = "ไม่สามารถเปิดไฟล์ PDF ได้";
        let errorCode = null;
        const blob = error.response && error.response.data
          ? error.response.data
          : null;

        if (blob instanceof Blob && blob.type.toLowerCase().includes('json')) {
          const text = await blob.text();
          const json = text ? JSON.parse(text) : {};

          errorMessage = json.message || errorMessage;
          errorCode = json.errorCode || null;
        } else if (error.response && error.response.data) {
          errorMessage = error.response.data.message || errorMessage;
          errorCode = error.response.data.errorCode || null;
        }

        if (errorCode === "URL_EXPIRED" && !hasRetried) {
          try {
            // pdfUrl carries a backend-signed, time-limited token; re-fetching
            // the receipt mints a fresh one without a full page reload.
            this.rawReceipt = await this.fetchData();

            await this.handlePreviewReceipt(this.receipt.pdfUrl, language, true);
          } catch (retryError) {
            this.$message.error(errorMessage);
          }

          return;
        }

        this.$message.error(errorMessage);
      }
      finally {
        this.isPreviewLoading = false;
      }
    },
    async handleClickSendReceiptButton(key) {
      const { isValid, error } = isValidReceiptUserName(this.form.name);

      if (isValid) {
        if (this.isInFirstHalfHourNow()) {
          this.$message.error("ไม่สามารถส่ง eztax ตอนครึ่งชั่วโมงแรกได้ เพราะระบบ run auto");
          return;
        }

        if (key === "CONFIRM") {
          try {
            await MessageBox.confirm(`ยืนยันการจอง "เลขที่ใบเสร็จ" และข้อมูลใบเสร็จ`, {
              confirmButtonText: "ตกลง",
              cancelButtonText: "ยกเลิก",
            });
          } catch {
            return;
          }
        } else {
          try {
            await MessageBox.confirm(
              `ยืนยันการส่ง${this.receipt.type}\nหมายเหตุ: หากต้องการจัดส่งในนามนิติบุคคล กรุณาเพิ่มเลขสาขา`,
              {
                confirmButtonText: "ตกลง",
                cancelButtonText: "ยกเลิก",
              }
            );
          } catch {
            return;
          }
        }

        const taxIdEdited = this.form.taxId ? this.form.taxId : undefined;

        const taxId = this.isEditTaxId
          ? this.form.taxId
          : this.rawReceipt.tax_id_field;

        try {
          this.isSending = true;

          const id = this.getRouteReceiptId();
          if (!id) {
            return;
          }
          const params = this.hasBranchNumber
            ? {
                branch_number: this.form.branchNumber,
                tax_id: taxId,
                issued_at: this.form.issuedAt.toISO(),
                name: this.form.name,
                address:
                  this.clientAddressForm || this.rawReceipt.receipt_address,
                withholding_images: this.withholdingTaxKeyAlbum,
                invoice_id: this.rawReceipt.invoice_id,
              }
            : {
                issued_at: this.form.issuedAt.toISO(),
                name: this.form.name,
                address:
                  this.clientAddressForm || this.rawReceipt.receipt_address,
                tax_id: taxIdEdited,
                withholding_images: this.withholdingTaxKeyAlbum,
                invoice_id: this.rawReceipt.invoice_id,
              };

          if (!["CONFIRM", "SEND"].includes(key))
            throw new Error("ไม่ได้ระบุชนิดของใบเสร็จ");

          if (key === "CONFIRM") {
            await baanRueJaiClient.admin.subscriptions.receipts.postConfirm(
              id,
              params
            );
          }

          if (key === "SEND") {
            // Send To Eztax
            if (this.receipt.canSendToEztax) {
              await baanRueJaiClient.admin.subscriptions.receipts.postSend(
                id,
                this.selectedLanguage.value
              );
            }

            // Resend To Eztax
            if (this.receipt.canResendToEztax) {
              await baanRueJaiClient.admin.subscriptions.receipts.postResend(
                id,
                this.selectedLanguage.value
              );
            }
          }

          await this.setup();
        } catch (err) {
          if (err.response && err.response.data && err.response.data.message) {
            if (
              err.response.data.errorCode === "PAYMENT_RESPONSE_NOT_MATCH_ERR"
            ) {
              this.$message.error("ระบบเช็คการตัดเงินไม่สำเร็จ (payment not match)");
              return;
            }

            this.$message.error(err.response.data.message);
          } else if (err.message) {
            this.$message.error(err.message);
          } else {
            this.$message.error("ไม่สามารถส่ง eztax ได้ กรุณาลองใหม่อีกครั้ง");
          }
        } finally {
          this.isSending = false;
        }
      } else {
        this.nameError = error;
        this.showErrorDialog = true;
      }
    },
    handleClickChangeAddressButton() {
      this.addressDialog.isShow = true;
    },
    async updateReceiptAddress(addressForm) {
      const id = this.getRouteReceiptId();
      if (!id) {
        return;
      }
      const {
        tumbon,
        address,
        intlAddress,
        countryCode,
        countryName,
        language
      } = addressForm || {};

      if (!tumbon && !address && !intlAddress && !countryCode) {
        return;
      }

      const params = {
        name: this.form.name,
        issued_at: this.form.issuedAt,
        tax_id: this.form.taxId,
        branchNumber: this.form.branchNumber || null,
        address: {
            ...tumbon,
            ...address ? { address } : {},
            ...intlAddress && countryCode
              ? {
                  international_address: intlAddress,
                  country_code: countryCode,
                  country_name: countryName
                }
              : {},
            language
          }
      };

      // Update address
      await baanRueJaiClient.admin.subscriptions.receipts.updateReceiptInformation(
        id,
        params
      );

      this.isHiddenDrecryptButton = false
    },
    async handleConfirmAddress(isConfirm) {
      // Cancel
      if (!isConfirm) {
        this.addressDialog.isShow = false;
        if (this.clientAddressForm) {
          this.addressForm = { ...this.clientAddressForm };
        } else {
          this.addressForm = { ...this.tempAddressForm };
        }

        this.searchTumbons = null;

        this.selectedAddress = {
          ...this.selectedAddress,
          temp: this.selectedAddress.current
        };

        return;
      }

      if (this.isSending) return;
      this.isSending = true;

      try {
        // Get address form
        const {
          address: addressInput,
          intlAddress: intlAddressInput,
          countryCode: countryCodeInput
        } = this.addressForm;

        // Validate address form
        const isAddressError = this.isTempIntlAddressSelected
          ? await this.validateAddressForm(intlAddressInput, true)
          : await this.validateAddressForm(addressInput);
        if (isAddressError) {
          return;
        }

        // Validate selected country code for international address
        if (this.isTempIntlAddressSelected && !countryCodeInput) {
          return;
        }

        // Set selected address
        const { temp } = this.selectedAddress;
        this.selectedAddress = {
          ...this.selectedAddress,
          current: temp,
          value: temp
        };

        // Set address form
        const baseAddressForm = {
          ...this.addressForm,
          language: this.getLangCode()
        };
        const { address: tempAddress } = this.tempAddressForm;

        this.clientAddressForm = this.isTempIntlAddressSelected ? {
          ...baseAddressForm,
          ...tempAddress ? { address: tempAddress } : {},
          intlAddress: intlAddressInput,
          countryCode: countryCodeInput,
          countryName: getCountryByCode(countryCodeInput).name
        } : {
          ...baseAddressForm,
          address: addressInput,
          intlAddress: null,
          countryCode: null,
          countryName: null
        };

        await this.updateReceiptAddress(this.clientAddressForm);

        // Set language
        this.rawReceipt.address = { ...this.clientAddressForm };
        this.setupLanguage(this.rawReceipt.address);

        this.addressDialog.isShow = false;
        // เมื่อกดบันทึกจะไม่ให้กดส่ง EZTax เลยต้องกดยืนยันข้อมูลก่อน
        this.markPendingConfirm()
      } catch (error) {
        this.$message.error("ไม่สามารถเปลี่ยนที่อยู่ได้");
      } finally {
        this.isSending = false;
      }
    },
    async validateSelectedAddress(addressForm, isTempIntlAddressSelected = false) {
      if (!addressForm) {
        return;
      }

      if (isTempIntlAddressSelected) {
        await this.validateAddressForm(addressForm.intlAddress, true);
      } else {
        await this.validateAddressForm(addressForm.address);
      }
    },
    async validateAddressForm(address, isIntlAddress = false) {
      const errorField = isIntlAddress
        ? 'intlAddressError'
        : 'addressError';

      if (!address) {
        this[errorField] = "กรุณาใส่ที่อยู่";

        return true;
      }

      const isValid = await this.validateEnglishInput(address)

      if (!isValid) {
        this[errorField] = "กรอกเฉพาะภาษาที่เลือกเท่านั้น";

        return true;
      }

      this[errorField] = "";

      return false;
    },
    handleClickChangeClientNameButton() {
      this.confirmDialog.isShow = true;
    },
    handleClickChangeTaxIdButton() {
      this.taxIdDialog.isShow = true;
    },
    handleClickDeleteReceiptButton() {
      this.confirmDeleteReceiptDialog.isShow = true;
    },
    async handleConfirm(isConfirm) {
      if (!isConfirm) {
        this.confirmDialog.isShow = false;
        this.form.tempName = this.form.name
        return;
      }

      if (this.isSending) return;
      this.isSending = true;

      try {
        const id = this.getRouteReceiptId();
      if (!id) {
        return;
      }

        this.form.name = this.form.tempName;

        const params = { name: this.form.name };

        await baanRueJaiClient.admin.subscriptions.receipts.updateReceiptInformation(
          id,
          params
        );

        this.confirmDialog.isShow = false;
        // เมื่อกดบันทึกจะไม่ให้กดส่ง EZTax เลยต้องกดยืนยันข้อมูลก่อน
        this.markPendingConfirm()
      } catch (error) {
        this.$message.error("ไม่สามารถเปลี่ยนชื่อได้");
      } finally {
        this.isSending = false;
      }
    },
    async handleConfirmTaxId(isConfirm) {
      if (!isConfirm) {
        this.taxIdDialog.isShow = false;
        this.form.tempTaxId = this.form.taxId;
        return;
      }

      if (this.isSending) return;
      this.isSending = true;

      try {
        const id = this.getRouteReceiptId();
      if (!id) {
        return;
      }

        this.form.taxId = this.form.tempTaxId;

        const params = { tax_id: this.form.taxId };

        await baanRueJaiClient.admin.subscriptions.receipts.updateReceiptInformation(
          id,
          params
        );

        this.taxIdDialog.isShow = false;
        // เมื่อกดบันทึกจะไม่ให้กดส่ง EZTax เลยต้องกดยืนยันข้อมูลก่อน
        this.markPendingConfirm()
      } catch (error) {
        this.$message.error("ไม่สามารถเปลี่ยนเลขประจำตัวผู้เสียภาษีได้");
      } finally {
        this.isSending = false;
      }
    },
    async handleConfirmCancel(isConfirm) {
      if (!isConfirm) {
        this.confirmDeleteReceiptDialog.isShow = false;
        return;
      }

      if (this.isSending) return;
      this.isSending = true;

      try {
        const id = this.getRouteReceiptId();
      if (!id) {
        return;
      }
        const params = { purpose: this.receiptDeleteReason };

        await baanRueJaiClient.admin.subscriptions.receipts.postDeleteExampleReceipt(
          id,
          params
        );

        this.$message.success("ลบตัวอย่างใบเสร็จสำเร็จ");
        this.$router.push({ name: "ReceiptDashboardPage" });
      } catch (e) {
        this.$message.error("ไม่สามารถลบตัวอย่างใบเสร็จได้");
        throw e;
      } finally {
        this.isSending = false;
      }
    },
    async handleSearchZipCode(queryString) {
      try {
        const params = { zip_code: queryString };
        const response = await baanRueJaiClient.admin.addresses.list(params);

        this.searchTumbons = response.data.result;
      } catch {
        this.$message.error("ไม่สามารถค้นหารหัสไปรษณีย์ได้");
      }
    },
    handleChangeAddressForm(key, value) {
      this.addressForm[key] = value;

      switch (key) {
        case "zip_code":
          this.handleChangeAddressZipCodeForm(value);
          break;
        case "amphur_code":
          this.handleChangeAddressAmphurCodeForm(value);
          break;
        default:
          break;
      }
    },
    handleChangeAddressZipCodeForm(val) {

      // Reset Adress Form
      if (!val) {
        this.addressForm.province_code = null
        this.addressForm.amphur_code = null
        this.addressForm.tumbon = null
        return
      }

      // Validate Search Tumbons
      if (!Array.isArray(this.searchTumbons)) return

      // Filter Tumbons
      const tumbons =  this.searchTumbons.filter(
        e => e.zip_code === val
      )
      // Validate Tumbons
      if (tumbons.length === 0) return

      // Address Props
      const [{ province_code: provinceCode, amphur_code: amphurCode }] = tumbons

      // Set Address Form
      this.addressForm.province_code = provinceCode
      this.addressForm.amphur_code = amphurCode
      this.addressForm.tumbon = tumbons.length === 1 ? tumbons[0] : null
    },
    handleChangeAddressAmphurCodeForm(val) {
      if (!val) {
        return;
      }

      switch (this.selectableTumbons.length) {
        case 1:
          [this.addressForm.tumbon] = this.selectableTumbons;
          break;
        default:
          this.addressForm.tumbon = null;
          break;
      }
    },
    handleClickChangeIssuedAtButton() {
      this.issuedAtDialog.isShow = true;
    },
    handleClickAddBranchNumberButton() {
      this.addBranchNumberDialog.isShow = true;
    },
    handleClickEditBranchNumberButton() {
      this.editBranchNumberDialog.isShow = true;
    },
    async handleConfirmAddBranchNumber(isConfirm) {
      if (!isConfirm) {
        this.addBranchNumberDialog.isShow = false;
        this.form.tempBranchNumber = "";
        return;
      }

      if (this.isSending) return;
      this.isSending = true;

      try {
        this.addBranchNumberDialog.isShow = false;

        this.form.branchNumber = this.form.tempBranchNumber;

        const id = this.getRouteReceiptId();
      if (!id) {
        return;
      }

        const params = { branch_number: this.form.branchNumber };

        await baanRueJaiClient.admin.subscriptions.receipts.updateReceiptInformation(
          id,
          params
        );

        // เมื่อกดบันทึกจะไม่ให้กดส่ง EZTax เลยต้องกดยืนยันข้อมูลก่อน
        this.markPendingConfirm()
      } catch (error) {
        this.$message.error("ไม่สามารถเพิ่มเลขสาขาผู้เสียภาษีได้");
      } finally {
        this.isSending = false;
      }
    },
    async handleConfirmEditBranchNumber(isConfirm) {
      if (!isConfirm) {
        this.editBranchNumberDialog.isShow = false;
        this.form.tempBranchNumber = this.form.branchNumber
        return;
      }

      if (this.isSending) return;
      this.isSending = true;

      try {
        const id = this.getRouteReceiptId();
      if (!id) {
        return;
      }

        this.form.branchNumber = this.form.tempBranchNumber;

        const params = { branch_number: this.form.branchNumber };

        await baanRueJaiClient.admin.subscriptions.receipts.updateReceiptInformation(
          id,
          params
        );

        this.editBranchNumberDialog.isShow = false;
        // เมื่อกดบันทึกจะไม่ให้กดส่ง EZTax เลยต้องกดยืนยันข้อมูลก่อน
        this.markPendingConfirm()
      } catch (error) {
        this.$message.error('ไม่สามารถเพิ่มเลขสาขาผู้เสียภาษีได้');
      } finally {
        this.isSending = false;
      }
    },
    async handleConfirmIssuedAt(isConfirm) {
      if (!isConfirm) {
        this.issuedAtDialog.isShow = false;
        this.form.tempIssuedAt = this.form.issuedAt
        return;
      }

      if (this.isSending) return;
      this.isSending = true;

      try {
        const id = this.getRouteReceiptId();
      if (!id) {
        return;
      }

        this.form.issuedAt = this.form.tempIssuedAt;

        const params = { issued_at: this.form.issuedAt };

        await baanRueJaiClient.admin.subscriptions.receipts.updateReceiptInformation(
          id,
          params
        );

        this.issuedAtDialog.isShow = false;
        // เมื่อกดบันทึกจะไม่ให้กดส่ง EZTax เลยต้องกดยืนยันข้อมูลก่อน
        this.markPendingConfirm()
      } catch (error) {
        this.$message.error('ไม่สามารถเปลี่ยนวันที่ได้');
      } finally {
        this.isSending = false;
      }
    },
    handleClickAddOfflinePdfReceiptButton() {
       this.isShowSelectPdfDialog = true;
    },
    handleCancelSelectPdfDialog() {
      this.isShowSelectPdfDialog = false;
    },
    async handleConfirmSelectPdfDialog(pdfFile) {
      if (this.isSending) return;
      this.isSending = true;

      try {
        const offlinePdfKey = !R.isNil(pdfFile)
          ? await uploadPublicFile(pdfFile, "receipt")
          : null;

        const offlinePdfName = !R.isNil(pdfFile)
          ? pdfFile.name
          : null

        const params = {
          offline_pdf_key: offlinePdfKey,
          offline_pdf_name: offlinePdfName
        }

        const id = this.getRouteReceiptId();
      if (!id) {
        return;
      }

        await baanRueJaiClient.admin.subscriptions.receipts.putOfflinePdf(
          id,
          params
        );

        await this.setup();
        this.isShowSelectPdfDialog = false;
      } catch {
        this.$message.error('ไม่สามารถบันทึก ใบเสร็จนอกระบบได้');
      } finally {
        this.isSending = false;
      }
    },
    async handleFileNotChangedPdfDialog(pdfFile) {
      if (!pdfFile) {
        await this.handleConfirmSelectPdfDialog(null);
      }

      this.isShowSelectPdfDialog = false;
    },
    handleClickAddSelectWithholdingAlbumDialog() {
      this.isShowSelectWithholdingImageAlbum = true;
    },
    handleCancelSelectWithholdingAlbumDialog() {
      this.isShowSelectWithholdingImageAlbum = false;
    },
    async handleConfirmSelectWithholdingAlbumDialog(album) {
      const withholdingTaxKeyAlbum = album
        && album.allImageToAlbum
        && album.allImageToAlbum.length > 0
        ? getKeyByUrlPath(album.allImageToAlbum)
        : undefined

      if (!this.rawReceipt.invoice_id) {
        this.$message.error('ไม่สามารถบันทึกรูปใบกำกับภาษี หรือ ไม่มีข้อมูลใบกำกับภาษี');
        return
      }

      this.rawReceipt.withholding_images = withholdingTaxKeyAlbum && album.allImageToAlbum
        ? album.allImageToAlbum
        : []

      this.withholdingTaxKeyAlbum = withholdingTaxKeyAlbum || []
      this.isShowSelectWithholdingImageAlbum = false;

      if (
        !this.showSendReceiptButton
        && !this.receipt.isDuplicateReceiptByInvoice
      ) {
        this.updateWithholdingTaxAlbum()
      }
    },
    async updateWithholdingTaxAlbum() {
      if (this.isSending) return;
      this.isSending = true;

      try {
        await baanRueJaiClient.admin.subscriptions.receipts.putWithholdingTaxImageKeys(
          this.rawReceipt.invoice_id,
          {
            withholding_tax_keys: this.withholdingTaxKeyAlbum
              && this.withholdingTaxKeyAlbum.length > 0
              ? this.withholdingTaxKeyAlbum
              : null
          }
        );

        this.isShowSelectWithholdingImageAlbum = false;
        this.$message.success("บันทึกเรียบร้อย");
      } catch {
        this.$message.error('ไม่สามารถบันทึก รูปใบกำกับได้');
      } finally {
        this.isSending = false;
      }
    },
    async handleDecryptTaxId() {
      try {
        const id = this.getRouteReceiptId();
      if (!id) {
        return;
      }
        const response = await backendAdminClient.receipt.getDecryptedTaxId(id);

        this.receipt.client.taxId = response.data.result.tax_id;
        this.isHiddenDrecryptButton = true;
      } catch (error) {
        this.$message.error("ไม่สามารถเข้าถึงได้");
      }
    },
    createAddressLine1() {
      const { rawReceipt, clientAddressForm } = this;

      if (clientAddressForm && clientAddressForm.intlAddress) {
        return clientAddressForm.intlAddress;
      }

      if (clientAddressForm && clientAddressForm.address) {
        return clientAddressForm.address;
      }

      if (rawReceipt && rawReceipt.address && rawReceipt.address.international_address) {
        return rawReceipt.address.international_address;
      }

      return rawReceipt.line_one.replace(/null/g, "");
    },
    createAddressLine2() {
      const { rawReceipt, clientAddressForm } = this;

      if (clientAddressForm && clientAddressForm.countryName) {
        return clientAddressForm.countryName;
      }

      if (clientAddressForm && clientAddressForm.tumbon) {
        return this.formattedAddress(clientAddressForm.tumbon);
      }

      if (rawReceipt && rawReceipt.address && rawReceipt.address.country_name) {
        return rawReceipt.address.country_name;
      }

      if (rawReceipt && rawReceipt.address) {
        return this.formattedAddress(rawReceipt.address);
      }

      return rawReceipt.line_two.replace(/null/g, "");
    },
    formattedAddress(address) {
      const addressParts = this.isEnglish ? [
        address.pre_tumbon_en,
        address.tumbon_name_en,
        address.pre_amphur_en,
        address.amphur_name_en,
        address.province_name_en,
        address.zip_code
      ] : [
        `${address.pre_tumbon}${address.tumbon_name}`,
        `${address.pre_amphur}${address.amphur_name}`,
        address.province_name,
        address.zip_code
      ];

      return addressParts.join(' ').trim();
    },
    getLangCode() {
      return this.isEnglish ? "en" : "th";
    },
    getAddressType(index) {
      return this.addressOptions[index].value;
    },
    isLangDefault() {
      const defaultLanguage = this.getDefaultLangOrFallback(this.rawReceipt.address);

      return this.selectedLanguage && this.selectedLanguage.value === defaultLanguage;
    },
    async validateEnglishInput(input) {
      if (!this.isEnglish) {
        return true;
      }

      const regex = /^[A-Za-z0-9\s.,/-]*$/;

      return regex.test(input);
    },
    handleCountrySelected(value) {
      this.addressForm.countryCode = value;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.container {
  padding-top: $space;
  padding-bottom: $space;
}

.label {
  font-size: 14px;
  color: #777;
}

.preview {
  display: inline-block;
  border-radius: 5px;
  border: 1px solid #dcdfe6;
  min-width: 120px;
  padding: 8px 30px;
  font-size: 1rem;
  text-align: center;
  background: white;
  cursor: pointer;

  &:hover {
    text-decoration: none;
    color: black;

    background: #efefef;
  }

  &.disabled {
    cursor: not-allowed;
    opacity: 0.6;

    &:hover {
      background: white;
    }
  }
}

.name {
  width: 250px;
}

.branch-number {
  width: 250px;
}

.offline-user {
  font-size: 18px;
  color: rgb(252, 76, 76);
}

.offline-user-detail {
  font-size: 14px;
  color: rgb(252, 76, 76);
}

.button-content {
  width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  font-size: 16px;
  color: #4a4a4a;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  outline: none;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.2s ease;
}

.button-content:hover {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}

.el-select-dropdown__item {
  margin-block: 8px;
}

.warning {
  font-size: 13px;
  color: rgb(252, 76, 76);
}

.address-options {
  display: flex;
  flex-direction: column;
}

.el-input,
.el-textarea,
.el-select {
  width: 250px;
}
</style>
